import { Component, EventEmitter, Output, ViewChild, forwardRef } from '@angular/core';
import { LongOperationDirective } from 'src/app/common/directives/long-operations/long-operations.directive';
import { DialogDefaultComponent } from '../dialog-default/dialog-default.component';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent extends DialogDefaultComponent {
  @Output() public onConfirm: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onCancel: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(forwardRef(() => LongOperationDirective), { static: false })
  public spinner: LongOperationDirective;

  public closeModal(): void {
    this.activeModal.close();
  }

  public override confirmAction(): void {
    this.onConfirm.emit();
    this.spinner.appendSpinnerToButton('modal-btn-confirmAction');
  }

  public override closeDialog(): void {
    this.onCancel.emit();
    this.closeModal();
  }

  public override onDismiss(): void {
    this.onCancel.emit();
    this.closeModal();
  }
}
